import store from "./store";
export default {
    endpoint: process.env.API_ENDPOINT,
    getOptions(endpoint, method, params) {
        if (method === undefined) {
            method = "GET";
        }
        if (params === undefined) {
            params = {};
        }
        if (store.state.showOtherPlacesData) {
            params.showOtherPlaceData = true;
        }
        let result = {
            url: this.getApiEndpoint(endpoint),
            method: method,
            headers: this.getAuthHeader(),
        };
        if (method === "GET") {
            result.params = params;
        } else {
            result.body = params;
        }
        return result;
    },
    getAuthHeader() {
        return {
            Authorization: `Bearer ${store.state.user.token}`,
        };
    },
    getApiEndpoint(endpoint) {
        return `${this.endpoint}/${endpoint}`;
    },
};
